import { delay } from '@/core/utils/timeout.utils';

type ShellNavApi = {
  resetTab: (
    tab: string,
    originalHref: string,
    originalRouteOptions?: unknown,
  ) => void;
  changeTab: (tab: string, path: string, routeOptions?: unknown) => void;
};

let shellNav: ShellNavApi | null = null;

const SHELL_NAV_WAIT_MS = 2000;
const SHELL_NAV_POLL_MS = 50;

export function registerShellNav(nav: ShellNavApi | null) {
  shellNav = nav;
}

export function getShellNav(): ShellNavApi | null {
  return shellNav;
}

/** Wait until IonTabs has registered NavContext (cold NFC / universal-link). */
export async function waitForShellNav(
  timeoutMs = SHELL_NAV_WAIT_MS,
): Promise<ShellNavApi | null> {
  const existing = getShellNav();
  if (existing?.resetTab) {
    return existing;
  }

  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await delay(SHELL_NAV_POLL_MS);
    const nav = getShellNav();
    if (nav?.resetTab) {
      return nav;
    }
  }

  return getShellNav();
}
